module.exports = __webpack_public_path__ + "media/images/sec_6-4-7ed7f398616ffd15708081a508281596.png";